import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import DotsIcon from "Assets/SVG/DotsIcon";
import { IPrintSizeDto } from "Apis/Models/IPrintDto";

interface IProps {
    printSizes?: IPrintSizeDto[];
    isLoading: boolean;
}
const PrintSizeList = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { printSizes, isLoading } = props;
    
    const navigate = useNavigate();
    
    return (
        <List<IPrintSizeDto> data={printSizes} loading={isLoading} columns={[
            {
                title: t('name'),
                textRender: (record) => record.name
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) => <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/prints/size/edit/${record.id}`)} ><DotsIcon /></FlexRow>
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default PrintSizeList
